<template>
<div id="nissan-quiz-question-ipad" class="nissan-quiz-screen">
<div>
<div
  v-if="!questionTimerComplete && !showAnswer"
  id="nissan-quiz-timercircle-icon"
>
  <svg class="timer-circle" height="100" width="100" viewBox="0 0 100 100">
    <circle
      class="outline"
      cx="50"
      cy="50"
      r="40"
    />
    <circle
      class="timer"
      cx="50"
      cy="50"
      r="40"
      v-bind:style="{ 'stroke-dashoffset': dashOffset }"
    />
  </svg>
  <div id="nissan-questioncountdown-text">{{timerText}}</div>
</div>


<div
  v-if="showAnswer && hasAnswer && selectedAnswer === correctAnswer"
  id="nissan-quiz-correctanswer-icon"></div>
<div
  v-if="showAnswer && hasAnswer && selectedAnswer !== correctAnswer"
  id="nissan-quiz-incorrectanswer-icon"></div>
<div
  v-if="(!hasAnswer || !showAnswer) && questionTimerComplete"
  id="nissan-quiz-timesup-icon"></div>
<div
  v-if="!hasAnswer && showAnswer"
  id="nissan-quiz-timesup-icon"></div>


<div id="nissan-quiz-questioncount" v-html="pagination"></div>
<h2 id="QuestionText" class="nissan-quiz-question" v-html="currentQuestion.quiz_question"></h2>
<div>
    <div>
        <div data-value="A" @click.capture="selectAnswer" id="AnswerButtonA" class="nissan-quiz-answerbutton" :class="buttonClassA" v-html="currentQuestion.quiz_answer_a"></div>
    </div>
    <div>
        <div data-value="B" @click.capture="selectAnswer" id="AnswerButtonB" class="nissan-quiz-answerbutton" :class="buttonClassB" v-html="currentQuestion.quiz_answer_b"></div>
    </div>
    <div>
        <div data-value="C" @click.capture="selectAnswer" id="AnswerButtonC" class="nissan-quiz-answerbutton" :class="buttonClassC" v-html="currentQuestion.quiz_answer_c"></div>
    </div>
</div>

<div v-if="showNextButton">
  <div
    @click="nextQuestion"
    class="nissan-quiz-nextbutton"
  >
    <span>NEXT</span>
  </div>
</div>
</div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Questions',
  data() {
    return {
      canShowNextButton: false,
    };
  },
  computed: {
    ...mapGetters([
      'config',
      'currentQuestion',
      'currentQuestionIndex',
      'currentQuestionCount',
      'questionTimerComplete',
      'selectedAnswer',
      'correctAnswer',
      'showAnswer',
      'remainingQuestionTimeInSeconds',
    ]),
    pagination() {
      return `${this.currentQuestionIndex + 1}/${this.currentQuestionCount}`;
    },
    dashOffset() {
      const offset = 740 + ((Number(this.timerText) / 15) * 260);
      return offset;
    },
    timerText() {
      let remainingSeconds = this.remainingQuestionTimeInSeconds;
      if (remainingSeconds < 0) {
        remainingSeconds = 0;
      }
      return remainingSeconds ? `${remainingSeconds}` : '';
    },
    hasAnswer() {
      return this.selectedAnswer !== '';
    },
    buttonClassA() {
      return this.buttonClass('A');
    },
    buttonClassB() {
      return this.buttonClass('B');
    },
    buttonClassC() {
      return this.buttonClass('C');
    },
    showNextButton() {
      return this.canShowNextButton && this.config.tierType === 'TIER3';
    },
  },
  watch: {
    questionTimerComplete(completed) {
      if (this.config.tierType !== 'TIER3') { return; }
      if (completed) {
        this.$root.$emit('requestShowAnswer');
        this.canShowNextButton = true;
      }
    },
  },
  methods: {
    ...mapMutations([
      'setSelectedAnswer',
      'setQuestionTimerComplete',
      'setRemainingQuestionTimeInSeconds',
    ]),
    selectAnswer(event) {
      if (!this.showAnswer && !this.questionTimerComplete && this.selectedAnswer === '') {
        this.setSelectedAnswer({ value: event.target.dataset.value });

        if (this.config.tierType === 'TIER3') {
          this.$root.$emit('requestShowAnswer');
          this.canShowNextButton = true;
        }
      }
    },
    buttonClass(letter) {
      let buttonClass = '';
      if (this.showAnswer) {
        if (this.selectedAnswer === letter && this.correctAnswer === letter) {
          buttonClass = 'active';
        } else if (this.selectedAnswer === letter && this.correctAnswer !== letter) {
          buttonClass = 'wrong';
        } else if (this.selectedAnswer !== letter && this.correctAnswer === letter) {
          buttonClass = 'selected';
        } else {
          buttonClass = 'disabled';
        }
      } else if (this.questionTimerComplete && this.selectAnswer === '') {
        buttonClass = 'disabled';
      } else if (this.selectedAnswer === letter) {
        buttonClass = 'selected';
      } else {
        buttonClass = 'active';
      }
      return buttonClass;
    },
    nextQuestion() {
      if (this.config.tierType !== 'TIER3') { return; }
      if (this.currentQuestionIndex === this.currentQuestionCount - 1) { // last question
        this.canShowNextButton = false;

        this.$root.$emit('requestShowScores');
      } else {
        this.setRemainingQuestionTimeInSeconds({ value: 0 });
        this.$root.$emit('requestNextQuestion');
        this.canShowNextButton = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
 @import './../styles/_global.scss';
 @import './../styles/_variables.scss';

#nissan-quiz-question-ipad {
  overflow-y: scroll;
  padding-bottom: 30px;
}

.nissan-quiz-answerbutton {
  font-family: 'Nissan-Brand-Bold';
  width: 90%;
  padding: 10px;
  border-width: 1px;
  border-color: #FFFFFF;
  border-style: solid;
  color: #FFFFFF;
  display: table;
  font-size: 20px;
  margin: 10px auto 10px;
  text-align: center;
  &.active {
    color: #FFFFFF;
  }

  &.selected {
    background-color: #FFFFFF;
    color: #000000;
  }

  &.wrong {
    background-color: #AAAAAAAA;
    color: #000000;
  }

  &.disabled {
    opacity: 0.5;
  }
}
@media only screen and (min-width: 600px) {
  .nissan-quiz-answerbutton {
    width: 70%;
    padding: 35px;
    font-size: 25px;
    margin: 20px auto 60px;
  }
}

@media only screen and (max-width: 320px) {
  .nissan-quiz-answerbutton {
  font-size: 15px;
  margin: 5px auto 5px;
  }
}

.nissan-quiz-question {
  font-size: 25px;
  margin: 0 10px 20px;
  font-family: 'Nissan-Brand-Light';
}
@media only screen and (min-width: 600px) {
  .nissan-quiz-question {
    font-size: 40px;
    margin: 0 25px 50px;
  }
}
/* for iPhone5 */
@media only screen and (max-width: 320px) {
  .nissan-quiz-question {
    font-size: 18px;
    margin: 0 5px 10px;
  }
}


#nissan-quiz-questioncount {
  font-weight: bold;
  font-size: 25px;
  margin: 210px auto 20px;
  text-align: center;
}
@media only screen and (min-width: 600px) {
  #nissan-quiz-questioncount {
    font-size: 30px;
    margin: 400px auto 40px;
  }
}
/* for iPhone5 */
@media only screen and (max-width: 320px) {
  #nissan-quiz-questioncount {
    font-size: 20px;
    margin: 170px auto 20px;
  }
}


#nissan-quiz-correctanswer-icon {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  width: calc(200px * 0.6);
  height: calc(158px * 0.6);
  background: url("./../assets/correct.png") no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
@media only screen and (min-width: 600px) {
  #nissan-quiz-correctanswer-icon {
    top: 231px;
    width: calc(200px * 0.9);
    height: calc(158px * 0.9);
  }
}
/* for iPhone5 */
@media only screen and (max-width: 320px) {
  #nissan-quiz-correctanswer-icon {
    top: 100px;
    width: calc(200px * 0.4);
    height: calc(158px * 0.4);
  }
}


#nissan-quiz-incorrectanswer-icon {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  width: calc(200px * 0.6);
  height: calc(138px * 0.6);
  background: url("./../assets/incorrect.png") no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
@media only screen and (min-width: 600px) {
  #nissan-quiz-incorrectanswer-icon {
    top: 231px;
    width: calc(200px * 1);
    height: calc(138px * 1);
  }
}
/* for iPhone5 */
@media only screen and (max-width: 320px) {
  #nissan-quiz-incorrectanswer-icon {
    top: 100px;
    width: calc(200px * 0.4);
    height: calc(138px * 0.4);
  }
}


#nissan-quiz-timesup-icon {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  height: calc(97px * 0.8);
  width: calc(267px * 0.8);
  background: url("./../assets/timesup.png") no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}
@media only screen and (min-width: 600px) {
  #nissan-quiz-timesup-icon {
    top: 240px;
    height: 97px;
    width: 267px;
  }
}
/* for iPhone5 */
@media only screen and (max-width: 320px) {
  #nissan-quiz-timesup-icon {
    top: 110px;
    width: calc(267px / 2);
    height: calc(97px / 2);
  }
}
circle.timer {
  fill: transparent;
  stroke: #C10933;
  stroke-width: 6;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
}
circle.outline {
  fill: transparent;
  stroke: white;
  stroke-width: 6;
  stroke-dasharray: 1000;
  stroke-dashoffset: 600;
}

#nissan-quiz-timercircle-icon {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  height: 100px;
  width: 100px;
  text-align: center;
  border-radius: 100%;
  background-color: transparent;

}
.timer-circle {
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-90deg)
}

#nissan-questioncountdown-text {
  font-size: 50px;
  text-align: center;
  line-height: 100px;
}

@media only screen and (min-width: 600px) {
  #nissan-quiz-timercircle-icon {
    top: 210px;
    height: 140px;
    width: 140px;
    svg {
      height: 140px;
      width: 140px;
    }
  }
  #nissan-questioncountdown-text {
    font-size: 70px;
    line-height: 140px;
  }
}
@media only screen and (max-width: 320px) {
  #nissan-quiz-timercircle-icon {
    top: 90px;
    height: 70px;
    width: 70px;
    svg {
      height: 70px;
      width: 70px;
    }
  }
  #nissan-questioncountdown-text {
    font-size: 40px;
    line-height: 70px;
  }
}

h2 {
  font-size: 30px;
  color: #fff;
  text-align: center;
}

</style>
